import React from 'react';

import { Description, LediumForm, TitleAndDescription, UniqueName } from '@ledium/ui-common';
import { Container } from '@mui/material';

import ProjectEditorLightRecipeInfo from './Components/ProjectEditorLightRecipeInfo';
import ProjectEditorSelectRecipe from './Components/ProjectEditorSelectRecipe';
import ProjectEditorSpectrumMixList from './Components/ProjectEditorSpectrumMixList';

interface ProjectEditorViewProps {
    onSave: () => void;
    onClose: () => void;
}

const ProjectEditorView = ({ onSave, onClose }: ProjectEditorViewProps) => (
    <Container>
        <LediumForm onSubmit={() => onSave()} onCancel={onClose} header={<TitleAndDescription />}>
            <UniqueName />
            <Description />
            <ProjectEditorSelectRecipe />

            <ProjectEditorLightRecipeInfo />
            <ProjectEditorSpectrumMixList />
        </LediumForm>
    </Container>
);

export default ProjectEditorView;
